import * as React from 'react';
import { Fragment } from 'react';
import moment from 'moment';
import Week from './Week';
import { DATE_FORMAT } from './constants';
function Month(props) {
    var date = props.date, selected = props.selected, onDayClick = props.onDayClick, minDate = props.minDate, maxDate = props.maxDate;
    var mDate = moment(date, DATE_FORMAT);
    var month = mDate.format('M');
    var endOfMonth = mDate
        .clone()
        .endOf('M')
        .endOf('D');
    var currentDate = mDate
        .clone()
        .startOf('M')
        .startOf('D');
    var monthCells = [];
    while (currentDate.isSameOrBefore(endOfMonth)) {
        monthCells.push(React.createElement("tr", { className: "Calendar__week", key: currentDate.valueOf() },
            React.createElement(Week, { date: currentDate.format(DATE_FORMAT), selected: selected, onDayClick: onDayClick, minDate: minDate, maxDate: maxDate, month: month })));
        currentDate.isoWeekday(1).add(7, 'day');
    }
    return React.createElement(Fragment, null, monthCells);
}
export default Month;
//# sourceMappingURL=Month.js.map